<div class="waf-rules-actions d-flex align-items-center gap-1 mb-4">
  <bn-web-ui-button
    itemStyle="stroke"
    size="md"
    [lessPadding]="true">
    <div class="d-flex gap-1">
      <bn-web-ui-checkbox
        class="d-inline-block"
        size="sm"
        [animateTransition]="false"
        [ngModel]="allRulesChecked() && allGroupsChecked()"
        (ngModelChange)="onSelectAllChanged($event)" />
    </div>
  </bn-web-ui-button>
  <bn-web-ui-button
    itemStyle="stroke"
    size="md"
    [disabled]="noGroupsChecked()"
    (click)="actionClick('expand')"
    >Expand</bn-web-ui-button
  >
  <bn-web-ui-button
    itemStyle="stroke"
    size="md"
    [disabled]="noGroupsChecked()"
    (click)="actionClick('collapse')"
    >Collapse</bn-web-ui-button
  >
  <bn-web-ui-button
    itemStyle="stroke"
    size="md"
    [disabled]="noRulesChecked()"
    [loading]="batchDisableRulesLoading()"
    (click)="actionClick('disable')"
    >Disable</bn-web-ui-button
  >
  <bn-web-ui-button
    itemStyle="stroke"
    size="md"
    [disabled]="noRulesChecked()"
    [loading]="batchEnableRulesLoading()"
    (click)="actionClick('enable')"
    >Enable</bn-web-ui-button
  >
  <bn-web-ui-button
    itemStyle="stroke"
    size="md"
    [disabled]="noRulesChecked()"
    [loading]="batchLogRulesLoading()"
    (click)="actionClick('log')"
    >Log Only</bn-web-ui-button
  >
  <bn-web-ui-input
    class="waf-rules-actions__search"
    placeholder="Search"
    size="xs"
    [ngModel]="search()"
    [options]="{ rightAddons: [{ icon: 'search' }] }"
    (ngModelChange)="search.set($event)" />
</div>
<div
  class="waf-rules"
  style="--bs-gutter-y: 1.5rem">
  @if (filteredCustomRules().length > 0) {
    <h2 class="waf-rules__group__title text-500-medium text-bunny-dark mb-2 text-uppercase">Custom</h2>
  }
  <div
    cdkDropList
    class="waf-rules__group__group mb-4"
    [cdkDropListData]="filteredCustomRules()"
    (cdkDropListDropped)="onCustomRuleDrop($event)">
    @for (rule of filteredCustomRules(); track 'custom-rule-' + rule.ruleId) {
      <div
        cdkDrag
        cdkDragBoundary=".waf-rules__group__group"
        cdkDragLockAxis="y"
        class="ps-3 waf-rules__group__row d-flex text-dark-7 text-200-semi-bold"
        [cdkDragDisabled]="isReorderDisabled()">
        @if (
          isLoadingRows['rule-' + rule.ruleId]() ||
          (checkedRules()[rule.ruleId || ''] && (batchDisableRulesLoading() || batchEnableRulesLoading() || batchLogRulesLoading()))
        ) {
          <bn-web-ui-loading size="sm" />
        }
        <div class="waf-rules__group__title d-flex align-items-center justify-center flex-fill">
          <bn-web-ui-checkbox
            #ruleCheckbox
            class="me-2"
            size="sm"
            uniqueId="{{ rule.ruleId }}"
            [animateTransition]="false"
            [ngModel]="checkedRules()[rule.ruleId || '']"
            (ngModelChange)="onRuleCheckCheckboxToggle(rule.ruleId, $event)" />
          <div
            class="circle-icon me-1 cursor-pointer"
            [ngClass]="{ 'text-success-6': rule.isEnabled, 'text-danger-6': !rule.isEnabled, 'text-warning-light-6': rule.isLogging }"
            [tooltip]="rule.isLogging ? 'Logging only' : rule.isEnabled ? 'Enabled' : 'Disabled'"
            (click)="toggleActive(rule.ruleId, rule.isEnabled)">
            <fa-icon
              class="align-middle"
              [icon]="rule.isLogging ? 'exclamation-circle' : rule.isEnabled ? 'check-circle' : 'xmark-circle'" />
          </div>
          <span>{{ rule.description }}</span>
        </div>
        <div class="p-4"></div>
        <div
          cdkDragHandle
          class="waf-rules__group__drag-handle"
          tooltip="Drag to reorder"
          [class.is-disabled]="isReorderDisabled()"
          [isDisabled]="isReorderDisabled()">
          <div class="square">
            <fa-icon
              icon="grip-dots-vertical"
              size="sm" />
          </div>
        </div>
        <div class="waf-rules__group__collapse-toggle--placeholder">
          <div class="square">
            <bn-web-ui-dropdown-menu
              class="d-block h-100"
              [aboveLoader]="true"
              [items]="[
                { label: 'Delete', action: 'delete', id: rule.ruleId || -1 },
                { label: 'Edit', action: 'edit', id: rule.ruleId || -1 },
                { label: 'Disable', action: 'disable', id: rule.ruleId || -1, hide: !rule.isEnabled },
                { label: 'Enable', action: 'enable', id: rule.ruleId || -1, hide: rule.isEnabled && !rule.isLogging },
                { label: 'Log Only', action: 'log', id: rule.ruleId || -1, hide: rule.isLogging },
              ]"
              [options]="{ align: 'end', size: 'sm', closeOnItemClick: true, isFullSize: true }"
              (clickAction)="onDropdownClick($event, rule)">
              <div trigger>
                <button
                  bn-web-ui-button
                  itemStyle="invisible"
                  [isSquare]="true">
                  <fa-icon
                    icon="ellipsis"
                    size="lg" />
                </button>
              </div>
            </bn-web-ui-dropdown-menu>
          </div>
        </div>
      </div>
    }
  </div>

  @for (mainGroup of filteredMainGroups(); track mainGroupI; let mainGroupI = $index) {
    <div class="waf-rules__group mb-4">
      <h2 class="waf-rules__group__title text-500-medium text-bunny-dark mb-2">{{ mainGroup.name }}</h2>
      <!--    <h2 class="waf-rules__group__title text-500-medium text-bunny-dark mb-2">{{mainGroup.name}} / {{mainGroup.ruleset}}</h2>-->
      @for (ruleGroup of mainGroup?.ruleGroups; track ruleGroup.id; let rowI = $index) {
        <div
          class="waf-rules__group__row waf-rules__group__row__toggle d-flex text-dark-7 text-200-semi-bold"
          [ngClass]="{ 'is-open': expandedGroups()[ruleGroup.id || ''] }">
          <div
            class="d-flex align-items-center justify-center p-3 flex-fill"
            (click)="dropdownClicked(mainGroupI, rowI)">
            <bn-web-ui-checkbox
              #groupCheckbox
              class="me-2"
              size="sm"
              uniqueId="{{ ruleGroup.id }}"
              [animateTransition]="false"
              [ngModel]="checkedGroups()[ruleGroup.id || '']"
              (ngModelChange)="onRulesGroupCheckboxToggle(ruleGroup.id, $event)" />
            <div class="waf-table-badge me-2">
              <span
                class="circle-icon me-1"
                [ngClass]="{
                  'text-success-6': (ruleGroup | childRules).totalActive > 0,
                  'text-danger-6': !(ruleGroup | childRules).totalActive,
                  'text-warning-light-6': (ruleGroup | childRules).totalLogging === (ruleGroup | childRules).total,
                }"
                [tooltip]="
                  (ruleGroup | childRules).totalActive === 0
                    ? 'No rules are enabled'
                    : (ruleGroup | childRules).totalActive === (ruleGroup | childRules).total
                      ? (ruleGroup | childRules).total === 1
                        ? 'The rule is enabled.'
                        : 'All ' + (ruleGroup | childRules).total + ' rules are enabled.'
                      : (ruleGroup | childRules).totalActive +
                        ' of the ' +
                        (ruleGroup | childRules).total +
                        ' rule' +
                        ((ruleGroup | childRules).total > 1 ? 's' : '') +
                        ((ruleGroup | childRules).total > 1 ? ' are' : ' is') +
                        ' enabled'
                ">
                <fa-icon [icon]="(ruleGroup | childRules).totalActive > 0 ? 'check-circle' : 'xmark-circle'" />
              </span>
              <span class="active-count">{{ (ruleGroup | childRules).totalActive }}</span
              >/{{ (ruleGroup | childRules).total }}
            </div>
            <span>{{ ruleGroup.name }}</span>
          </div>
          <div class="p-3"></div>
          <div
            class="waf-rules__group__collapse-toggle cursor-pointer"
            [ngClass]="{ 'has-children': ruleGroup.rules.length }"
            (click)="toggleCollapse(ruleGroup.id)">
            <div class="square">
              <fa-icon [icon]="!expandedGroups()[ruleGroup.id || ''] ? 'chevron-down' : 'chevron-up'" />
            </div>
          </div>
        </div>
        <div
          class="waf-rules__group__row__children"
          [ngClass]="{ 'd-block': expandedGroups()[ruleGroup.id || ''], 'd-none': !expandedGroups()[ruleGroup.id || ''] }">
          @for (rule of ruleGroup.rules; track rule.ruleId + '' + ruleI; let ruleI = $index) {
            <div class="waf-rules__group__row--child d-flex text-dark-7 text-200-semi-bold">
              @if (
                isLoadingRows['rule-' + rule.ruleId]() ||
                (checkedRules()[rule.ruleId || ''] && (batchDisableRulesLoading() || batchEnableRulesLoading() || batchLogRulesLoading()))
              ) {
                <bn-web-ui-loading size="sm" />
              }
              <div class="waf-rules__group__title d-flex align-items-center justify-center flex-fill">
                <div class="connecting-line"></div>
                <bn-web-ui-checkbox
                  #ruleCheckbox
                  class="me-1"
                  size="sm"
                  uniqueId="{{ rule.ruleId }}"
                  [animateTransition]="false"
                  [ngModel]="checkedRules()[rule.ruleId || '']"
                  (ngModelChange)="onRuleCheckCheckboxToggle(rule.ruleId, $event)" />
                <div
                  class="circle-icon me-1 cursor-pointer"
                  [ngClass]="{ 'text-success-6': rule.isEnabled, 'text-danger-6': !rule.isEnabled, 'text-warning-light-6': rule.isLogging }"
                  [tooltip]="rule.isLogging ? 'Logging only' : rule.isEnabled ? 'Enabled' : 'Disabled'"
                  (click)="toggleActive(rule.ruleId, rule.isEnabled)">
                  <fa-icon [icon]="rule.isLogging ? 'exclamation-circle' : rule.isEnabled ? 'check-circle' : 'xmark-circle'" />
                </div>
                <span>{{ rule.description }}</span>
              </div>
              <div class="p-4"></div>
              <div class="waf-rules__group__collapse-toggle--placeholder">
                <div class="square">
                  <bn-web-ui-dropdown-menu
                    class="d-inline-block"
                    [aboveLoader]="true"
                    [items]="[
                      { label: 'Disable', action: 'disable', id: rule.ruleId || -1, hide: !rule.isEnabled },
                      { label: 'Enable', action: 'enable', id: rule.ruleId || -1, hide: rule.isEnabled && !rule.isLogging },
                      { label: 'Log Only', action: 'log', id: rule.ruleId || -1, hide: rule.isLogging },
                    ]"
                    [options]="{ align: 'end', size: 'sm', closeOnItemClick: true }"
                    (clickAction)="onDropdownClick($event, rule)">
                    <div trigger>
                      <button
                        bn-web-ui-button
                        itemStyle="invisible"
                        [isSquare]="true">
                        <fa-icon
                          icon="ellipsis"
                          size="lg" />
                      </button>
                    </div>
                  </bn-web-ui-dropdown-menu>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
